import { defineStore } from 'pinia'
import type { dynamicObj } from 'src/pages/assets';
import { docTypeApiService } from 'src/services';
import { isEmptyString, isUndefinedOrNull } from 'src/utils/general';
import { approve_before_export_v2, CONSTANTS } from 'src/constants';

export const useDocAttributesStore = defineStore('doc_attributes', {
  state: () => ({
    doc_type_key: '',
    loading_data: false,
    model: {} as dynamicObj,
    getReqPromise: null as Promise<string> | null,
    docTypeAttributes: {} as dynamicObj,
    getReqPromiseResolve: null as any,
    allDocTypesSettings: {} as dynamicObj,
  }),
  getters: {
    
  },
  actions: {

    async getDocTypeAllSettings () {
      if(this.allDocTypesSettings.length > 0) {
        return;
      }
      try {
        this.loading_data = true;

        const doc_type__attributes = approve_before_export_v2 + ','+ CONSTANTS.PO_MATCH_SERVER_SIDE + ','+ CONSTANTS.ALLOW_MULTIPLE_EXPORT_CONFIGURATIONS;

        const response = await docTypeApiService.getAllDocumentTypeAttributes(doc_type__attributes);
        if (response.success == false) {
            throw response;
        }

        for (const [docTypeKey, docType] of Object.entries(response.data)) {
          this.allDocTypesSettings[docTypeKey] = {} as dynamicObj;

          for(const item of docType as any) {
            this.allDocTypesSettings[docTypeKey][item.attribute_key] = item;
          }
        }

      } catch (err) {
        throw err;
      } finally {
        this.loading_data = false;
      }
    },
    getSettingsByDocTypeAndSettingKey(docType: string, key: string) {

      // await this.getDocTypeAllSettings();

      if(!this.allDocTypesSettings[docType] || !this.allDocTypesSettings[docType][key]) {
        return false;
      }

      const attributeValue = this.allDocTypesSettings[docType][key].attribute_value;
      if(attributeValue == 'true') {
        return true;
      } else if(attributeValue == 'false' || !attributeValue) {
        return false;
      }

       
      return attributeValue;
    },

    async fetchAttributes (doc_type: string) {

      if(!doc_type) {
        return;
      }

      if (this.doc_type_key == doc_type && this.getReqPromise) {

        return this.getReqPromise;
      }


      this.doc_type_key = doc_type;
      this.getReqPromise = new Promise((resolve) => {
        this.getReqPromiseResolve = resolve;
        this.getDocTypeSettings();
      });

      return this.getReqPromise;
    },
    
    // Do not call this method directly always use its promise function
    async getDocTypeSettings () {
      try {
          this.loading_data = true;
          const data = {
              doc_type_key: this.doc_type_key,
          }

          const response = await docTypeApiService.getAttributesByDocKey(data);
          if (response.success == false) {
              throw response;
          }
          
          // for (const [key, item] of Object.entries(response.data)) {
          //     const doc_attribute = item as dynamicObj;
          //     this.setSetting(doc_attribute.attribute_key, doc_attribute.attribute_value);
          // }



          const processedData = {} as dynamicObj  // To store the processed attribute values
          for (const entry of response.data) {
              const doc_attribute = entry as dynamicObj;

              // If this is the first time encountering this attribute_key, initialize it
              if (!processedData[doc_attribute.attribute_key]) {
                  processedData[doc_attribute.attribute_key] = [];
              }

              const value_element = {
                  sub_org_id: doc_attribute.sub_org_id,
                  value: doc_attribute.attribute_value,
                  id: doc_attribute.id,
              };

              
              if (doc_attribute.sub_org_id === null) {
                  const existingEntry = processedData[doc_attribute.attribute_key].find(
                      (entry: dynamicObj) => entry.sub_org_id === null
                  );
                  if (!existingEntry) {
                      processedData[doc_attribute.attribute_key].push(value_element);
                  }
              } else {
                  processedData[doc_attribute.attribute_key].push(value_element);
              }
          }


          for (const [key, value] of Object.entries(processedData)) {
              if (Array.isArray(value) && value.length > 1) {
                  this.setSetting(key, value);
                  this.docTypeAttributes[key] = value;
              } else {
                  // If only one entry, set the value directly
                  this.setSetting(key, value[0]?.value);
                  this.docTypeAttributes[key] = value[0];
              }
          }

          console.info('Processed Data:', this.model);
      } catch (err) {
          throw err;
      } finally {
          this.loading_data = false;

          if (this.getReqPromiseResolve) {
            this.getReqPromiseResolve();
          }
      }
    },


    getAttriValueByKeyAndSubOrgId(key:string, sub_org_id?: string | null) {
        const value = this.model[key];
    
        if (Array.isArray(value)) {
            if (isUndefinedOrNull(sub_org_id) || isEmptyString(sub_org_id)) {
              sub_org_id = null;
            }

            const entry = value.find((item:dynamicObj) => item.sub_org_id === sub_org_id);
            if (entry) {
               
              return entry.value;
            }

            return null;
        }
    
        if (value !== undefined) {
             
            return value;
        }
    
        return null;
    },

    setSetting (key: string, value: any) {

      // For Boolean
      if (typeof value === 'string') {
        const lowercase_value = value.toLowerCase();
        if (lowercase_value === 'true' || lowercase_value === 'false') {
          this.model[key] = lowercase_value === 'true';
          return;
        }
      }

      if (isUndefinedOrNull(value)) {
        return;
      }

      this.model[key] = value;
    },

    async setAttribute (attribute_key: string, attribute_value: any) {
      try {
          const data = {
              doc_type_key: this.doc_type_key,
              attribute_key,
              attribute_value
          }

          const response = await docTypeApiService.setAttribute(data);
          if (response.success == false) {
              throw response;
          }

      } catch (err) {
          throw err;
      } finally {

      }
    },

    resetDocAttributes () {
      this.doc_type_key = '';
      this.model = {} as dynamicObj;
      this.getReqPromise = null;
      this.getReqPromiseResolve = null;
    }
  },
})